export default __webpack_public_path__ + "img/28d8657c97924e0280ea66c3b4e98757.svg";